import { API_TIMEOUT, PRUEBA_KO, RESPONSE_KO, RESPONSE_OK } from "../utils/constants";

const submitForm = (pass, repass, optionalQuestion) => new Promise((resolve, reject) => setTimeout(() => (pass !== PRUEBA_KO ? resolve(RESPONSE_OK) : reject(RESPONSE_KO)), API_TIMEOUT));

export { submitForm };
